import { render, staticRenderFns } from "./DossierSaveButton.vue?vue&type=template&id=1cd23ddd&scoped=true&"
import script from "./DossierSaveButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./DossierSaveButton.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DossierSaveButton.vue?vue&type=style&index=0&id=1cd23ddd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd23ddd",
  null
  
)

export default component.exports